// extracted by mini-css-extract-plugin
module.exports = {"main":"Health_main__33tWp","circle":"Health_circle__5cLVr","loading":"Health_loading__2E3KM","ok":"Health_ok__2Cq3R","bad":"Health_bad__1oMtN"};